<template>
  <div>
    <div class="row">
      <div class="col-12">
        <h4>Restore</h4>
      </div>
    </div>
    <div class="row">
      <div class="col-6">
        <form enctype="multipart/form-data">
          <div class="form-group">
            Backup File:
            <div class="input-group mb-3">
              <div class="custom-file">
                <input type="file" class="custom-file-input" accept=".pbf" @change="processFile($event)">
                <label class="custom-file-label">{{ file_import.file_name }}</label>
              </div>
            </div>
          </div>
          <div v-show="file_import.progress !== 0">
            <label>Upload Progress:</label>
            <div class="progress">
              <div class="progress-bar" role="progressbar" :style="'width: ' + file_import.progress + '%;'"
                   :aria-valuenow="file_import.progress"
                   aria-valuemin="0"
                   aria-valuemax="100">{{ file_import.progress }}%
              </div>
            </div>
          </div>
          <br>
          <button type="button" class="btn btn-hub-primary" @click="uploadBackupFile()">Upload & Restore</button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: function () {
    return {
      file_import: {
        file_name: '',
        file: '',
        progress: 0
      }
    }
  },
  methods: {
    processFile (event) {
      this.file_import.file = event.target.files[0]
      this.file_import.file_name = event.target.files[0].name
    },
    onProgress (percent) {
      this.file_import.progress = percent
    },
    uploadBackupFile () {
      if (this.file_import.file !== '') {
        this.$store.dispatch('uploadBackupFile', {
          fileImport: this.file_import,
          onProgress: this.onProgress
        })
      } else {
        alert('Please select a backup to restore.')
      }
    }
  }
}
</script>

<style scoped>

</style>
